const BookTabs = (function(window, $) {

    function BookTabs() {
        this.tabButtonsWrap = $('.book-tab-buttons');
        this.tabButtons = this.tabButtonsWrap.find('a');
        this.tabContent = $('.tab-content > .has-toggle');

        if (this.tabButtons.length === 0) { // Some bookpages don't have book tab switches. See VER-4421
            let ean = $('meta[property="book:isbn"]').attr('content'); // Value contains EAN (not ISBN as is implied)
            let button = this.tabContent.find('[data-add-to-cart="' + ean + '"]');
            this.pushDataLayerEvent(button, ean, true);
        } else if (this.getEanFromUrl()) {
            this.toggleTab(this.getEanFromUrl(), true);
        } else {
            this.toggleTab(this.tabButtons.filter('[data-parent=0]').data('ean'), true);
        }

        this.addEvents();
    }

    BookTabs.prototype.addEvents = function() {
        this.tabButtons.on('click', this.handleClick.bind(this));
    };

    BookTabs.prototype.handleClick = function (e) {
        e.preventDefault();

        let target = $(e.target).closest('a');

        let bookType = target.data('type');
        let ean = target.data('ean');

        this.toggleTab(ean);
        this.buildUrl(target, bookType, ean);

    }

    BookTabs.prototype.toggleTab = function(ean, initial = false) {
        let button = this.tabButtonsWrap.find('[data-ean="' + ean + '"]');
        let tab = $('.ean-' + ean);

        if (! (button.length && tab.length)) {
            return;
        }

        this.tabButtons.removeClass('active');
        this.tabContent.removeClass('active');

        button.addClass('active');
        tab.addClass('active');

        this.toggleCover(button);

        if (ean) {
            this.pushDataLayerEvent(button, ean, initial);
        }
    }

    BookTabs.prototype.toggleCover = function(button) {
        let cover = button.data('cover');
        let coverBack = button.data('coverback');

        if (cover.length > 0) {
            $('#front-cover').attr('src', cover);
        }
        if (coverBack.length > 0) {
            $('#back-cover').attr('src', coverBack);
        }
    }

    BookTabs.prototype.buildUrl = function(target, bookType, ean) {
        let url = this.tabButtonsWrap.data('url').replace(/\/+$/, '');

        if (target.data('parent') != 0) {
            url = url + '/' + bookType + '/' + ean
        }

        history.replaceState(ean, '', url);
    }

    BookTabs.prototype.getEanFromUrl = function() {
        let matches = window.location.href.split(/[?#]/)[0].match(/\/(\d+)\/?$/);

        if (matches) {
            return matches[1];
        }

        return null;
    }

    /**
     * Fire event to GTM
     *
     * @param {string} ean
     * @param {boolean} initial Differentiate between original requested and book switches
     */
    BookTabs.prototype.pushDataLayerEvent = function(button, ean, initial) {

        let product = Events.createProduct(button, {
            item_id: ean 
        });
 
        // fire event (keep for backwards GA3 compatibility)
        // Events.fireEcommerceEventGA3(product);

        // Custom event 'productswitch' when tab toggles have been used (keep for future use')
        let eventName = initial ? 'ecommerce_view_item' : 'ecommerce_view_item';
        Events.fireEcommerceEvent('items', product, eventName);
    }

    return BookTabs;

}(window, jQuery));



export {BookTabs};
